import { useEffect, useLayoutEffect, useRef, useState } from "react";

import { PRIMER_TORNEO_TEXTO } from "./content";
import { useInView } from "./hooks";
import "./StickyDemoBar.css";

/** Espera antes de mostrar la barra: los observadores reportan un instante
 * después de montar; sin esto la barra parpadea al cargar la página. */
const ARM_DELAY_MS = 350;

/** Regla de visibilidad (pura, para pruebas): aparece cuando «Pedir demo» del
 * encabezado del sitio y el de la portada de /organizador ya salieron de
 * pantalla, y se oculta con el formulario (#demo) o el pie a la vista. */
export function shouldShowDemoBar(state: {
  armed: boolean;
  headerCtaVisible: boolean;
  heroCtaVisible: boolean;
  demoVisible: boolean;
  footerVisible: boolean;
}): boolean {
  return (
    state.armed && !state.headerCtaVisible && !state.heroCtaVisible && !state.demoVisible && !state.footerVisible
  );
}

/** Barra fija de /organizador en celular (≤860): «Haz tu primer torneo
 * gratis» + «Pedir demo». En escritorio el CSS la oculta. */
export function StickyDemoBar() {
  const headerCtaRef = useRef<Element | null>(null);
  const heroCtaRef = useRef<Element | null>(null);
  const demoRef = useRef<Element | null>(null);
  const footerRef = useRef<Element | null>(null);
  const [armed, setArmed] = useState(false);

  // Los elementos viven en otros componentes (encabezado, portada y pie), ya
  // pintados en el mismo commit: se toman antes de que useInView los observe.
  useLayoutEffect(() => {
    headerCtaRef.current = document.querySelector("[data-t123-header-cta]");
    // Botón «Pedir demo» de la portada (#inicio); si no existe, no estorba.
    heroCtaRef.current = document.querySelector('#inicio a[href$="#demo"]');
    demoRef.current = document.getElementById("demo");
    footerRef.current = document.querySelector("[data-t123-footer]");
  }, []);

  const headerCtaVisible = useInView(headerCtaRef);
  const heroCtaVisible = useInView(heroCtaRef);
  const demoVisible = useInView(demoRef);
  const footerVisible = useInView(footerRef);

  useEffect(() => {
    const timer = window.setTimeout(() => setArmed(true), ARM_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  const visible = shouldShowDemoBar({ armed, headerCtaVisible, heroCtaVisible, demoVisible, footerVisible });

  return (
    <div className={`t123-stickybar${visible ? " is-visible" : ""}`} aria-hidden={visible ? undefined : true}>
      <p className="t123-stickybar__text">{PRIMER_TORNEO_TEXTO}</p>
      <a className="t123-btn t123-btn--primary t123-stickybar__btn" href="#demo" tabIndex={visible ? undefined : -1}>
        Pedir demo
      </a>
    </div>
  );
}
